var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rect',{attrs:{"x":_vm.rectX,"y":_vm.rectY,"width":_vm.rectWidth,"height":_vm.rectHeight,"rx":_vm.borderRadius,"fill":_vm.ICON_COLORS[`bg_icon_${_vm.index + 1}`]}})
}
var staticRenderFns = []

export { render, staticRenderFns }